import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getValidatedCheckerCdes, getValidatedCheckerSteps } from '../lib/checker';

export const initializeChecker = createAction('CHECKER_INITIALIZE', (exercise, answers = []) => {
    return {
        payload: { exercise, answers },
    };
});

export const openStep = createAction('CHECKER_OPEN_STEP', (index) => {
    return {
        payload: { index },
    };
});

export const openCde = createAction('CHECKER_OPEN_CDE', (index) => {
    return {
        payload: { index },
    };
});

export const updateStep = createAction('CHECKER_UPDATE_STEP', (index, value) => {
    return {
        payload: { index, value },
    };
});

export const updateCde = createAction('CHECKER_UPDATE_CDE', (index, value) => {
    return {
        payload: { index, value },
    };
});

export const addCde = createAsyncThunk('CHECKER_ADD_CDE', async ({ exercise, cdes, index }) => {
    const validatedCdes = await getValidatedCheckerCdes(exercise, cdes);
    return { validatedCdes, index };
});

export const addStep = createAsyncThunk('CHECKER_ADD_STEP', async ({ exercise, steps, index, isCorrectable }) => {
    const validatedSteps = await getValidatedCheckerSteps(exercise, steps);
    return { validatedSteps, index, isCorrectable };
});

export const validate = createAsyncThunk(
    'CHECKER_VALIDATE',
    async ({ exercise }, { getState }) => {
        /** This is not-optimal but needed since multiple action and thunks happens in the same time */
        const {
            checker: { steps, cdes },
        } = getState();

        const validatedSteps = await getValidatedCheckerSteps(exercise, steps);
        const validatedCdes = await getValidatedCheckerCdes(exercise, cdes);

        return { validatedSteps, validatedCdes };
    },
    {
        condition: ({ exercise }, { getState }) => {
            const {
                checker: { exerciseId, isValidated },
            } = getState();

            return exerciseId === exercise.id && !isValidated;
        },
    },
);

export const deleteStep = createAction('CHECKER_DELETE_STEP', (index) => {
    return {
        payload: { index },
    };
});

export const deleteCde = createAction('CHECKER_DELETE_CDE', (index) => {
    return {
        payload: { index },
    };
});

export const closeAll = createAction('CHECKER_CLOSE_ALL');

export const ackSync = createAction('CHECKER_ACK_SYNC');

export const updateFinalAnswer = createAction('CHECKER_UPDATE_FINAL_ANSWER', (value) => {
    return {
        payload: { value },
    };
});
